import { data, type LoaderFunctionArgs, type MetaFunction } from 'react-router'
import { Button } from '#app/components/ui/button'
import { Card } from '#app/components/ui/card'
import { captureEvent } from '#app/lib/analytics/track.server'
import { getUser } from '#app/lib/supabase/auth'

export const meta: MetaFunction = () => {
	return [
		{ title: 'Extension Uninstalled - Task Sentry' },
		{
			name: 'description',
			content: "Thank you for trying Task Sentry. We'd love your feedback!",
		},
	]
}

export async function loader({ request }: LoaderFunctionArgs) {
	const { user, headers } = await getUser(request)

	let distinctId = 'anonymous-uninstall'
	let isAuthenticated = false

	// Use user ID if available (authenticated user)
	if (user?.id) {
		distinctId = user.id
		isAuthenticated = true
	}

	// Track the uninstall event server-side with user context if available
	captureEvent(distinctId, 'extension:uninstalled', {
		timestamp: Date.now(),
		method: 'redirect',
		userAgent: request.headers.get('user-agent'),
		authenticated: isAuthenticated,
	})

	return data({ user, isAuthenticated }, { headers })
}

export default function ExtensionUninstalled() {
	return (
		<div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
			<Card className="w-full max-w-lg space-y-6 p-8 text-center">
				<div className="mb-4 text-6xl">🥺</div>

				<h1 className="mb-4 text-3xl font-bold text-gray-900">
					Sorry to see you go!
				</h1>

				<p className="mb-6 text-lg text-gray-700">
					We'd love to know how we could have done better.
				</p>

				<Button asChild className="w-full">
					<a
						href="https://x.com/gianlucazinn"
						target="_blank"
						rel="noopener noreferrer"
						className="inline-flex items-center gap-2"
					>
						💬 Send Feedback on X
					</a>
				</Button>

				<div className="space-y-4 border-t border-gray-200 pt-6">
					<p className="text-sm text-gray-500">
						Thank you for giving Task Sentry a try! ✨
					</p>

					<div className="flex justify-center gap-3">
						<Button variant="outline" size="sm" asChild>
							<a href="/">Homepage</a>
						</Button>
						<Button variant="outline" size="sm" asChild>
							<a href="/account">Dashboard</a>
						</Button>
					</div>
				</div>
			</Card>
		</div>
	)
}
